
import { useTranslation } from 'react-i18next';

export function Experience() {
  const { t } = useTranslation('common');

  const timeline = [
    {
      period: t('experience.timeline.0.period'),
      title: t('experience.timeline.0.title'),
      description: t('experience.timeline.0.description'),
      icon: 'ri-building-line'
    },
    {
      period: t('experience.timeline.1.period'),
      title: t('experience.timeline.1.title'),
      description: t('experience.timeline.1.description'),
      icon: 'ri-flashlight-line'
    },
    {
      period: t('experience.timeline.2.period'),
      title: t('experience.timeline.2.title'),
      description: t('experience.timeline.2.description'),
      icon: 'ri-home-gear-line'
    },
    {
      period: t('experience.timeline.3.period'),
      title: t('experience.timeline.3.title'),
      description: t('experience.timeline.3.description'),
      icon: 'ri-government-line'
    },
    {
      period: t('experience.timeline.4.period'),
      title: t('experience.timeline.4.title'),
      description: t('experience.timeline.4.description'),
      icon: 'ri-global-line'
    },
    {
      period: t('experience.timeline.5.period'),
      title: t('experience.timeline.5.title'),
      description: t('experience.timeline.5.description'),
      icon: 'ri-user-star-line'
    },
    {
      period: t('experience.timeline.6.period'),
      title: t('experience.timeline.6.title'),
      description: t('experience.timeline.6.description'),
      icon: 'ri-shield-check-line'
    }
  ];

  return (
    <section id="historia" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('experience.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('experience.subtitle')}
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="relative">
            {/* Timeline line */}
            <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-orange-500 to-blue-900"></div>

            {timeline.map((item, index) => (
              <div 
                key={index}
                className={`relative mb-12 lg:mb-16 ${
                  index % 2 === 0 ? 'lg:text-left' : 'lg:text-right'
                }`}
              >
                <div className={`lg:w-1/2 ${index % 2 === 0 ? 'lg:pr-12' : 'lg:pl-12 lg:ml-auto'}`}>
                  <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
                    <div className={`flex items-center gap-4 mb-4 ${index % 2 === 0 ? '' : 'lg:flex-row-reverse'}`}>
                      <div className={`w-14 h-14 ${index % 2 === 0 ? 'bg-orange-500' : 'bg-blue-900'} rounded-full flex items-center justify-center flex-shrink-0`}>
                        <i className={`${item.icon} text-2xl text-white`}></i>
                      </div>
                      <div className={`px-4 py-2 ${index % 2 === 0 ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-900'} rounded-full font-bold text-sm whitespace-nowrap`}>
                        {item.period}
                      </div>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>

                {/* Timeline dot */}
                <div className="hidden lg:block absolute left-1/2 top-8 transform -translate-x-1/2 w-6 h-6 bg-white border-4 border-orange-500 rounded-full shadow-lg"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
